module.exports = __webpack_public_path__ + "img/teamtip_dashboard_start_202526_en.c483aaa5.png";